import { useSyncExternalStore } from 'react'

// Whether the BoxViewer is up as the centered modal, held outside redux so Modal and
// FullscreenModal can yield MUI's focus trap to a preview opened over them.

let isOpen = false
const listeners = new Set<() => void>()

const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

const getSnapshot = () => isOpen

export const setBoxViewerModalOpen = (open: boolean) => {
  if (isOpen === open) {
    return
  }
  isOpen = open
  listeners.forEach((listener) => listener())
}

export const useIsBoxViewerModalOpen = () => useSyncExternalStore(subscribe, getSnapshot)
